// @lumi/app-kit shared i18n vocabulary (ADR 0026 §7) — locale it.
// Byte-identical common.*/errors.* used across >=3 apps + owned by app-kit components.
// Apps merge appKitMessages under their own catalog; the no-shadow check forbids an
// app from redefining these keys. Generated from the per-app catalogs.
export default {
  // The sidebar's account menu + history buttons (suite design foundation, spec §4):
  // byte-identical across every chrome, so owned here rather than by nine app catalogs.
  accountMenu: {
    profile: 'Il mio profilo',
    settings: 'Impostazioni',
    theme: 'Aspetto',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    support: 'Assistenza',
    back: 'Indietro',
    forward: 'Avanti',
    collapseSidebar: 'Comprimi la barra laterale',
    expandSidebar: 'Espandi la barra laterale',
    // The account row of a phone-only account (issue 698): no name, no address.
    signedIn: 'Accesso effettuato',
  },
  // A sidebar entry another of the viewer's own roles opens (#1028): the
  // greyed entry's hint, its switch dialog, and the role list joiner.
  roleLock: {
    hint: 'Solo come {roles}. Cambia ruolo: in basso a sinistra, il tuo account → Ruolo.',
    body: 'Hai quest’area come {roles}. Ora stai lavorando come {active}.',
    action: 'Apri come {role}',
    where: 'Puoi cambiare ruolo in qualsiasi momento: in basso a sinistra, il tuo account → Ruolo.',
    listOr: '{list} o {last}',
  },
  common: {
    // Every DateField's calendar and typing hint (issue 823; People's own until then).
    datePicker: {
      open: 'Apri il calendario',
      previousMonth: 'Mese precedente',
      nextMonth: 'Mese successivo',
      month: 'Mese',
      year: 'Anno',
      clear: 'Cancella la data',
      dayToken: 'GG',
      monthToken: 'MM',
      yearToken: 'AAAA',
    },
    deactivate: 'Disattiva',
    revoke: 'Revoca',
    remove: 'Rimuovi',
    actions: 'Azioni',
    calendar: 'Calendario',
    cancel: 'Annulla',
    close: 'Chiudi',
    confirmTitle: 'Conferma',
    contactSupport: 'Contatta il supporto',
    copyLink: 'Copia link',
    edit: 'Modifica',
    language: 'Lingua',
    linkCopied: 'Link copiato',
    linkCopyFailed: 'Impossibile copiare il link',
    moduleListHeading: 'I tuoi moduli',
    moduleTeaserAction: 'Aggiungi in fatturazione',
    moduleTeaserHeading: 'Anche in lumi',
    moduleTeaserNote: 'Il proprietario del workspace, gli amministratori e i Billing Manager possono aggiungere questi moduli.',
    moduleTeaserTag: 'Non incluso nel tuo piano',
    no: 'No',
    nothingHere: 'Qui non c’è ancora nulla',
    ok: 'OK',
    refresh: 'Aggiorna',
    retry: 'Riprova',
    role: 'Ruolo',
    save: 'Salva',
    search: 'Cerca',
    switchModule: 'Cambia modulo',
    tabsNext: 'Mostra le schede successive',
    tabsPrevious: 'Mostra le schede precedenti',
    understood: 'Ho capito',
    userDeactivated: '{name} (account disattivato)',
    yes: 'Sì',
  },
  errors: {
    // ADR 0036 code-first branch (errorKeyFor): a backend `code` wins over the
    // status. `invalid_credentials` is what every login door answers a bad
    // sign-in with — a bare 401 would otherwise fall through to
    // `errors.unauthorized`, telling someone who mistyped their password that
    // their session expired (issue 364, F10). It never lets a caller tell an
    // unknown account apart from a mistyped password — the two answer
    // identically — so the copy names both fields.
    // `MASTER_INVITE_REJECTED` is people-api's fallback when the identity
    // service refuses an invitation payload without a code of its own (issue
    // 364, decisions round 1): without an entry here it degrades to the
    // status-derived message, which says nothing about what to look at. Its
    // sibling `MASTER_TENANT_NOT_FOUND` stays local to PersonDetailView on
    // purpose — that one names a next step specific to that screen.
    codes: {
      invalid_credentials: 'Accesso non riuscito. Controlla il tuo indirizzo e-mail e la password.',
      MASTER_INVITE_REJECTED: 'Questo invito è stato rifiutato perché i dati della persona non sono stati accettati. Controlla l’indirizzo e-mail e il nome nella scheda della persona e riprova.',
      PERSON_EMAIL_INVALID: 'Questa persona non ha un indirizzo e-mail valido, quindi non è possibile invitare un accesso. Correggi prima l’indirizzo nella scheda della persona.',
      PERSON_PHONE_INVALID: 'Questo numero di cellulare non è valido. Inseriscilo in formato internazionale, con + e il prefisso del paese, ad es. +39 312 345 6789.',
      PERSON_ACCESS_PHONE_TAKEN: 'Un’altra persona ha già un accesso con questo numero di cellulare, o lo sta ricevendo. Un numero, una persona.',
      PHONE_ACCESS_UNAVAILABLE: 'L’accesso tramite numero di cellulare non è disponibile qui, per questo spazio di lavoro o per il paese di questo numero. Usa invece un indirizzo e-mail.',
      SUITE_ROLE_NEEDS_EMAIL: 'Questa persona accede con un numero di cellulare e non ha un indirizzo e-mail. I ruoli della suite ricevono e-mail legali, di fatturazione e di consenso, quindi richiedono un indirizzo.',
      OWNER_NEEDS_EMAIL: 'Questa persona accede con un numero di cellulare e non ha un indirizzo e-mail. Il titolare riceve e-mail legali e contrattuali, quindi la titolarità richiede un indirizzo.',
      RECORD_CHANGED: 'Qualcun altro ha modificato questo record mentre lo stavi modificando. Ricaricalo: i tuoi dati restano salvati come bozza.',
    },
    appUpdatedBody: 'Questa pagina non è stata caricata completamente perché l’app è stata aggiornata. Ricarica per continuare.',
    appUpdatedTitle: 'È disponibile una nuova versione',
    conflict: 'L’azione è in conflitto con lo stato attuale. Ricarica e riprova.',
    contactSupport: 'Contatta l’assistenza',
    exhausted: 'Sembra davvero rotto. Ci dispiace. Contatta l’assistenza.',
    failedTitle: 'Azione non riuscita',
    forbidden: 'Non hai i permessi per questa azione.',
    loadFailedTitle: 'Impossibile caricare',
    network: 'Nessuna connessione al server. Controlla la connessione a Internet.',
    notFound: 'L’elemento richiesto non è stato trovato.',
    rateLimited: 'Troppe richieste. Attendi un momento e riprova.',
    recordChangedReload: 'Qualcun altro ha salvato questo record dopo che lo hai aperto, quindi la tua modifica non è stata applicata. Ricarica per vedere la versione attuale: i tuoi dati restano salvati e si possono ripristinare.',
    refreshFailedTitle: 'Questi dati potrebbero non essere aggiornati',
    server: 'Si è verificato un errore del server. Riprova più tardi.',
    timeout: 'Il server non ha risposto in tempo. Riprova tra un momento.',
    unauthorized: 'La tua sessione è scaduta. Accedi di nuovo.',
    unexpected: "Si è verificato un errore durante la visualizzazione. Riprova.",
    validation: 'Controlla i dati inseriti.',
  },
  notReady: {
    title: 'Questo non è ancora pronto per te',
    body: 'Il tuo spazio di lavoro è ancora in preparazione. Ti riporteremo al workspace tra 5 secondi.',
  },
  // The workspace this app was opened on does not exist, or can no longer be
  // reached (issue 364, F57). ONE message for BOTH causes on purpose: ats-api
  // answers a suspended tenant and an unknown slug identically, and splitting
  // the copy would confirm which workspaces exist. `body` therefore names no
  // cause, and nothing on the page names a workspace, a slug or a person.
  tenantUnavailable: {
    title: 'Questo spazio di lavoro non è raggiungibile',
    body: 'Questo spazio di lavoro non esiste oppure al momento non è raggiungibile: controlla l’indirizzo che hai aperto.',
    accountLead: 'I tuoi dati e le tue fatture restano disponibili nel tuo account lumi.',
    accountCta: 'Vai al tuo account lumi',
    supportLead: 'Se si tratta di un errore, scrivici e lo risolviamo insieme.',
    // The signed-in person's own membership is gone (issue 669): a revoked demo guest,
    // or a demo that ended under an open tab.
    ended: {
      title: 'Non hai accesso a questo spazio di lavoro',
      body: 'Hai effettuato l’accesso, ma non sei (o non sei più) membro di questo spazio di lavoro. Se eri ospite in una demo, la demo è terminata o il tuo invito è stato ritirato.',
      accountLead: 'Il tuo account lumi personale non è interessato.',
    },
  },
  billing: {
    banner: {
      suspendedTitle: 'Spazio bloccato',
      suspendedMessage: 'Questo spazio di lavoro è sospeso. Contattaci per ripristinare l’accesso.',
      lockedBody: 'Questo spazio di lavoro è stato bloccato a causa di un problema di fatturazione in sospeso. L’accesso a tutti i moduli è attualmente sospeso.',
      lockedSupportLead: 'Per ripristinare l’accesso, contatta il nostro team di assistenza:',
      lockedSupportCta: 'Contatta l’assistenza',
      lockoutOn: 'In caso contrario verrà bloccato il {date}.',
      fixCardTitle: 'Aggiorna la tua carta',
      fixCardBody: 'Il tuo ultimo pagamento è stato rifiutato perché la carta non è stata accettata.',
      fixCardCta: 'Aggiorna carta',
      softDeclineTitle: 'Assicura il tuo pagamento',
      softDeclineBody: 'Non siamo riusciti a incassare il tuo ultimo pagamento e riproveremo automaticamente. Assicurati che il tuo metodo di pagamento abbia fondi sufficienti.',
      softDeclineCta: 'Verifica metodo di pagamento',
      scaTitle: 'Conferma il tuo pagamento',
      scaBody: 'La tua banca deve confermare questo pagamento prima che possiamo incassarlo.',
      scaCta: 'Conferma pagamento',
      recoveryError: 'Non è stato possibile avviare il pagamento in questo momento. Riprova tra un attimo.',
      chargebackTitle: 'Salda il tuo pagamento stornato',
      chargebackBody: 'La tua banca ha stornato un pagamento, che è quindi di nuovo dovuto. Aggiungi un metodo di pagamento per saldarlo.',
      chargebackCta: 'Aggiungi metodo di pagamento',
      trialTitle: 'Aggiungi un metodo di pagamento',
      trialBody: 'La tua prova è terminata. Aggiungi un metodo di pagamento per mantenere attivo questo spazio di lavoro.',
      trialCta: 'Aggiungi metodo di pagamento',
      reviewTitle: 'Controlla la tua fatturazione',
      reviewBody: 'Questo spazio di lavoro richiede un’azione di fatturazione per rimanere attivo.',
      reviewCta: 'Gestisci fatturazione',
      contactTitle: 'Contatta il tuo amministratore',
      contactBody: 'Un problema di fatturazione richiede attenzione per mantenere attivo questo spazio di lavoro.',
    },
  },
  legalNoticeBanner: {
    title: 'Gli avvisi legali richiedono la tua attenzione',
    employeeBody: 'Gli inviti sono in pausa finché l’informativa sulla privacy per i dipendenti non è completa.',
    candidateBody: 'Il portale carriere è offline finché le informative per i candidati non sono complete.',
    imprintBody: 'Il portale carriere è offline finché non vengono salvate le note legali.',
    candidateImprintBody: 'Il portale carriere è offline finché le informative per i candidati non sono complete e non vengono salvate le note legali.',
    cta: 'Apri Avvisi legali',
  },
  // The one "needs you" strip (issue 713): the list label, the hide control and the
  // per-item sentences. A lone legal item reuses legalNoticeBanner.* word for word.
  needsYou: {
    label: 'Ha ancora bisogno di te:',
    hide: 'Nascondi',
    timeRules: {
      link: 'Regole sull’orario di lavoro',
      cta: 'Verifica',
      body: 'Le regole sull’orario di lavoro non sono ancora state verificate. lumi calcola con le regole di legge predefinite e si limita ad avvisare finché qualcuno non conferma che vanno bene per la vostra azienda.',
    },
    legal: { link: 'Compila le informative legali' },
    billing: {
      link: 'Completa la fatturazione',
      cta: 'Apri la fatturazione',
      bodyBoth: 'Aggiungi i dati di fatturazione e un metodo di pagamento, così il tuo spazio di lavoro continua a funzionare senza interruzioni.',
      bodyInvoiceDetails: 'Aggiungi i tuoi dati di fatturazione, così le tue fatture vengono emesse correttamente.',
      bodyPaymentMethod: 'Aggiungi un metodo di pagamento, così il tuo spazio di lavoro continua a funzionare senza interruzioni.',
    },
  },
  // Consented temporary support access (ADR 0041): the marker every module
  // chrome shows beside the tenant name while a supporter is inside a grant.
  supportAccess: {
    label: 'Accesso assistenza',
    until: 'Accesso assistenza temporaneo fino al {until} — tutto ciò che fai qui viene registrato nell’audit log di questo tenant.',
  },
  // Idle session timeout (issue 265). Owned by app-kit's IdleLogoutGuard, except
  // idleSignedOut — the login pages (workspace, system-admin) render that after
  // the bounce, and it is the same suite-wide policy statement, so it stays in one
  // place rather than drifting between the two login surfaces.
  session: {
    idleTitle: 'Ci sei ancora?',
    idleBody: 'Sei inattivo da un po’. Per la tua sicurezza ti disconnetteremo automaticamente.',
    idleStay: 'Resta connesso',
    idleSignedOut: 'Sei stato disconnesso dopo {minutes} minuti di inattività. Accedi di nuovo.',
  },
  // Browser form drafts (owner-stamped, 7 days, typed values only — app-kit
  // utils/formDraftStorage.ts). Owned by app-kit's DraftBanner and by the
  // sign-out warning every module chrome shows, so the wording lives here instead
  // of drifting across five app catalogs.
  formDrafts: {
    bannerTitle: 'Bozza non salvata',
    bannerSavedAt: 'Salvata su questo dispositivo: {when}',
    bannerRecordChanged: 'Il record è cambiato rispetto a questa bozza. Ripristina rimette solo i campi che hai modificato.',
    restore: 'Ripristina',
    discard: 'Scarta',
    closeTitle: 'Scartare i dati inseriti in «{form}»?',
    closeBody: 'I dati non salvati andranno persi.',
    closeConfirm: 'Scarta',
    closeCancel: 'Continua a modificare',
    recordChangedTitle: 'Modificato da un’altra persona',
    reload: 'Ricarica',
    forms: {
      'apprentice': {
        planStation: 'Fase del piano di formazione',
        skillCatalogue: 'Catalogo delle competenze',
        trainingData: 'Dati della formazione',
      },
      'ats': {
        workflowEditor: 'Editor del flusso di lavoro',
      },
      'backoffice': {
        applicationForm: 'Candidatura',
        createApplication: 'Nuova candidatura',
        customField: 'Campo personalizzato',
        customFields: 'Campi personalizzati',
        emailSettings: 'Impostazioni email',
        jobAd: 'Annuncio di lavoro',
        jobAdTemplate: 'Modello di annuncio di lavoro',
        jobEdit: 'Posizione',
        portalSettings: 'Impostazioni del portale carriere',
        ravenBatchPublish: 'Pubblicazione annunci in blocco',
        ravenPublish: 'Pubblicazione annuncio',
        role: 'Ruolo',
        suggestion: 'Suggerimento',
        supportTicket: 'Ticket di supporto',
        supportTicketReply: 'Risposta al ticket di supporto',
        talentEdit: 'Profilo del talento',
        workflowAction: 'Azione del flusso di lavoro',
        workflowCondition: 'Condizione del flusso di lavoro',
        workflowGuard: 'Guardia del flusso di lavoro',
        workflowState: 'Stato del flusso di lavoro',
        workflowTransition: 'Transizione del flusso di lavoro',
      },
      'people': {
        bankAccount: 'Conto bancario',
        companyProfile: 'Profilo aziendale',
        employmentContract: 'Contratto di lavoro',
        myProfile: 'Il mio profilo',
        onboardingTemplate: 'Modello di onboarding',
        oneTimePayment: 'Pagamento una tantum',
        orgUnit: 'Unità organizzativa',
        person: 'Persona',
        taxProfile: 'Profilo fiscale',
        wageAssignment: 'Cessione dello stipendio',
      },
      'system-admin': {
        fileQuota: 'Quota file',
        skillDetail: 'Dettaglio della competenza',
        suggestionNotes: 'Note sul suggerimento',
      },
      'time': {
        blueprint: 'Modello di orario di lavoro',
        leaveRequest: 'Richiesta di assenza',
        leaveType: 'Tipo di assenza',
        orgGroup: 'Gruppo organizzativo',
        project: 'Progetto',
        role: 'Ruolo',
        userProfile: 'Profilo utente',
        weekGrid: 'Griglia settimanale',
        workTimeModel: 'Modello orario di lavoro',
      },
      'user': {
        ssoSettings: 'Impostazioni SSO',
      },
      'workspace': {
        billingProfile: 'Profilo di fatturazione',
        wizardGeneral: 'Procedura guidata di configurazione',
      },
    },
  },
  // Suite-wide legal footer (issue 221): the § 5 DDG imprint and the privacy
  // notice of the Lumi entity live once on the marketing site, and every app
  // links to them through the shared LegalLinksFooter. The wording is
  // byte-identical everywhere, so it belongs to app-kit rather than to any app.
  legal: {
    imprint: 'Note legali',
    privacy: 'Privacy',
    terms: 'Termini e condizioni',
    label: 'Informazioni legali',
    employeeNotice: 'Privacy presso {company}',
  },
  dataImport: {
    title: 'Importazione dati',
    intro: 'Importa dati esistenti da un vecchio sistema: carica un file, verifica la mappatura dei campi, esamina la prova e poi conferma.',
    backToList: 'Torna alla panoramica',
    sourceSystem: 'Sistema di origine',
    cancelled: 'Questa importazione è stata annullata.',
    steps: {
      upload: 'Caricamento',
      analysis: 'Analisi',
      mapping: 'Mappatura',
      dryRun: 'Prova',
      commit: 'Conferma',
    },
    status: {
      uploaded: 'Caricato',
      analyzing: 'Analisi in corso',
      mapping_ready: 'Verifica mappatura',
      dry_running: 'Prova in corso',
      dry_run_ready: 'Prova pronta',
      committing: 'Conferma in corso',
      completed: 'Completato',
      failed: 'Non riuscito',
      cancelled: 'Annullato',
    },
    formats: {
      csv: 'CSV',
      xlsx: 'Excel',
      json: 'JSON',
      sql_dump: 'Dump SQL',
      hropen: 'HR Open JSON',
    },
    transforms: {
      none: 'Diretto',
      date: 'Data',
      number: 'Numero',
      boolean: 'Sì/No',
      enum_map: 'Mappatura valori',
      split_name: 'Dividi nome',
      concat: 'Concatena',
      const: 'Costante',
      skip: 'Ignora',
    },
    upload: {
      sourceSystem: 'Nome del sistema di origine',
      sourceSystemHint: 'Salvato come riferimento: reimportare lo stesso file aggiorna i record invece di duplicarli.',
      sourceSystemPlaceholder: 'es. vecchio_hr',
      sourceSystemFirst: 'Indica prima il sistema di origine.',
      dropHint: 'Trascina qui un file o sfoglia',
      formats: 'CSV, Excel (XLSX), JSON o dump SQL — max 50 MB',
      browse: 'Scegli file',
      uploading: 'Caricamento …',
    },
    running: {
      uploaded: 'Avvio dell\'analisi …',
      analyzing: 'Analisi del file …',
      dry_running: 'Prova in corso …',
      committing: 'Scrittura dei dati …',
      hint: 'I file grandi possono richiedere alcuni minuti. Questa pagina si aggiorna automaticamente.',
    },
    failed: {
      title: 'Importazione non riuscita',
    },
    mapping: {
      hint: 'Verifica la mappatura proposta: una destinazione per tabella e un campo per colonna. Le righe evidenziate sono proposte incerte.',
      targetEntity: 'Destinazione',
      skipTable: 'Non importare',
      skippedTable: 'Questa tabella non verrà importata.',
      ignoreColumn: 'Ignora',
      sourceColumn: 'Colonna',
      sample: 'Valori di esempio',
      targetField: 'Campo di destinazione',
      transform: 'Trasformazione',
      preview: 'Anteprima',
      rowCount: '{count} righe',
      patternHint: 'Schema data, es. DD.MM.YYYY',
      multiTargetHint: 'Destinazione {index} di {total} — lo stesso file alimenta più destinazioni',
      valueMap: 'Associa valori',
      valueMapHint: 'Associa i valori di origine ai valori consentiti nel sistema. I valori non associati producono un errore per riga nella prova. Basato su un massimo di 20 valori di esempio distinti della colonna.',
      valueMapUnmapped: '— non associato —',
      addColumnRow: 'Mappa di nuovo una colonna',
      customFieldBadge: 'Campo personalizzato',
      createCustomField: 'Crea un nuovo campo personalizzato…',
      confirm: 'Conferma mappatura e avvia la prova',
    },
    report: {
      dryRunHint: 'Prova — non è stato ancora scritto nulla. Controlla i totali e gli errori prima di confermare.',
      completedHint: 'Importazione completata. I dati sono stati scritti.',
      created: 'Creati',
      updated: 'Aggiornati',
      skipped: 'Saltati',
      errors: 'Errori',
      errorList: '{count} errori',
      downloadErrors: 'Scarica tutti gli errori',
      row: 'Riga',
      errorMessage: 'Messaggio',
      backToMapping: 'Torna alla mappatura',
      commit: 'Conferma dati',
      commitConfirmTitle: 'Confermare i dati?',
      commitConfirmBody: 'L\'importazione scriverà ora in questo modulo. I nuovi record vengono creati, quelli esistenti aggiornati. Non è possibile annullare automaticamente.',
      commitStarted: 'Conferma avviata: i dati vengono scritti.',
    },
    // An import report's error row, worded from the facts the module sent (rowErrorText.ts).
    rowErrors: {
      required: '{field} è vuoto, ma ogni riga richiede un valore.',
      unknownField: '{field} non può essere importato qui.',
      invalidEnum: '«{value}» non è un valore valido per {field}. Valori validi: {allowed}. Associalo nella fase di mappatura, in «Associa valori».',
      unresolved: {
        person: 'Nessuna persona trovata con {keys} «{value}».',
        supervisor: 'Nessun responsabile gerarchico trovato con {keys} «{value}».',
        functionalSupervisor: 'Nessun responsabile funzionale trovato con {keys} «{value}».',
        orgUnit: 'Nessuna unità org. trovata con {keys} «{value}».',
        parentOrgUnit: 'Nessuna unità org. superiore trovata con {keys} «{value}».',
      },
      supervisorRequired: 'Nessun responsabile gerarchico trovato con {keys} «{value}», e questa persona non ne ha ancora uno. Ogni persona attiva ne ha bisogno: importa prima il responsabile gerarchico oppure indicane uno già esistente.',
      unknownEntity: 'Questo tipo di dati non può essere importato qui.',
      emailLinked: 'Questa persona accede a lumi con questo indirizzo e-mail, quindi l’importazione non può modificarlo. Inserisci nel file il suo indirizzo attuale oppure non importare la colonna e-mail.',
      supervisorMissing: 'Ogni persona attiva ha bisogno di un responsabile gerarchico e questa persona non ne ha. Indicane uno nel file oppure crea prima il responsabile.',
      transformFailed: 'Non è stato possibile convertire «{value}» nella colonna {field}. Controlla il formato in «Trasformazione» nella fase di mappatura.',
      transformFailedNoValue: 'Non è stato possibile convertire un valore nella colonna {field}. Controlla il formato in «Trasformazione» nella fase di mappatura.',
      unknown: 'Questa riga non è stata importata. I dettagli sono nel file degli errori.',
      ambiguous: {
        collision: '{ref}: «{value}» corrisponde a due record diversi: a uno come ID esterno, a un altro come {other}. L’importazione non tira a indovinare: rendi univoco il riferimento nel file.',
        otherSystem: '{ref}: «{value}» non è un ID esterno di questo sistema di origine ma di «{system}», e corrisponde anche a un record come {other}. L’importazione non tira a indovinare: importa con il sistema di origine «{system}» se si tratta dello stesso, oppure rendi univoco il riferimento.',
        holderHasExternalId: '{ref}: «{value}» corrisponde solo come {other}, e quel record ha già l’ID esterno «{otherId}» in questo sistema di origine. L’importazione non tira a indovinare: usa «{otherId}» se intendi quello.',
      },
      refs: {
        person: 'Persona',
        supervisor: 'Responsabile gerarchico',
        functionalSupervisor: 'Responsabile funzionale',
        orgUnit: 'Unità org.',
        parentOrgUnit: 'Unità org. superiore',
      },
      supervisorInactive: {
        supervisor: 'Il responsabile gerarchico indicato non è più attivo e quindi non può guidare nessuno.',
        functional: 'Il responsabile funzionale indicato non è più attivo e quindi non può guidare nessuno.',
      },
      supervisorUnconfirmed: {
        supervisor: 'Il responsabile gerarchico indicato non è ancora stato confermato dalle risorse umane e quindi non può guidare nessuno. Confermalo prima in People.',
        functional: 'Il responsabile funzionale indicato non è ancora stato confermato dalle risorse umane e quindi non può guidare nessuno. Confermalo prima in People.',
      },
      datesInverted: 'La data in {end} è precedente a quella in {start}.',
      agreementCodeInvalid: '{field} ammette solo lettere, cifre, «-», «_» e «.», al massimo 60 caratteri e senza spazi.',
      statusTransition: 'Un contratto non può passare da «{from}» a «{to}».',
      reportingCycle: 'Questa assegnazione chiuderebbe la linea gerarchica in un cerchio.',
      ambiguousOrgCode: 'Più unità org. di tipo diverso hanno il codice «{value}». Indica quella giusta con il suo ID esterno.',
      keys: {
        externalId: 'ID esterno',
        employeeNumber: 'numero di matricola',
        code: 'codice',
      },
    },
    list: {
      title: 'Importazioni precedenti',
      file: 'File',
      system: 'Sistema di origine',
      status: 'Stato',
      created: 'Creato',
      empty: 'Ancora nessuna importazione.',
      open: 'Apri',
      delete: 'Elimina',
      deleteConfirmTitle: 'Eliminare l’importazione?',
      deleteConfirmBody: '“{file}” e tutti i relativi file di importazione verranno rimossi. I dati già acquisiti restano.',
      deleted: 'Importazione “{file}” eliminata.',
    },
  },
  dataExport: {
    title: 'Esportazione HR Open',
    intro: 'Esporta i dati di questo modulo come HR Open 4.5 (HR-JSON), convalidati rispetto allo standard.',
    create: 'Crea esportazione',
    creating: 'Creazione …',
    download: 'Scarica',
    password: {
      title: 'Password ZIP — visibile solo ora',
      hint: 'L’export viene creato come ZIP protetto da password (AES-256) perché contiene dati personali. Copia la password ora — non verrà mostrata di nuovo. Aprire con ad es. 7-Zip, WinZip o Keka.',
      copy: 'Copia password',
      copied: 'Copiata',
    },
    empty: 'Ancora nessuna esportazione.',
    columns: {
      standard: 'Standard',
      status: 'Stato',
      items: 'Record',
      created: 'Creato',
    },
    status: {
      queued: 'In coda',
      generating: 'Generazione',
      completed: 'Completato',
      failed: 'Non riuscito',
    },
  },
  // The demo's module picker (ADR 0083): the fork offers it on entry, the bar's
  // reset confirmation again. A locked module is booked (or core) and always in.
  // RoleNameTranslations.vue (ADR 0086): a custom role's names in other
  // languages, or the notice a system role gets instead.
  roleNames: {
    translations: 'Traduzioni',
    translationsHint: 'Il nome in altre lingue. I campi vuoti mostrano il nome qui sopra.',
    systemHint: 'Ruolo di sistema: lumi lo nomina in ogni lingua. Nome e descrizione non si possono modificare, le autorizzazioni sì.',
  },
  demoModules: {
    legend: 'Moduli nella demo',
    booked: 'Acquistato — sempre incluso',
  },
  demoStage: {
    label: 'Demo',
    viewingAs: 'Visualizza come',
    personaPlaceholder: 'Scegli un ruolo',
    persona: {
      team_lead: 'Responsabile del team',
      employee: 'Dipendente',
      hr_admin: 'Amministratore HR',
      recruiter: 'Recruiter',
      ats_admin: 'Amministratore ATS',
      council_member: 'Membro del consiglio aziendale',
      apprentice: 'Apprendista',
      trainer: 'Formatore',
    },
    personaDoes: {
      team_lead: 'Decide sulle richieste di assenza e correzione e valuta le candidature.',
      employee: 'Registra giornate di lavoro, richiede assenze e fa correggere le registrazioni.',
      hr_admin: 'Crea persone, progetti e offerte di lavoro.',
      recruiter: 'Porta le candidature attraverso la prima selezione e pianifica i colloqui.',
      ats_admin: 'Decide sulle assenze, valuta le candidature e crea offerte di lavoro.',
      council_member: 'Esprime il voto del consiglio aziendale su offerte di lavoro e proposte.',
      apprentice: 'Spunta le tappe del piano di formazione e registra giornate di lavoro.',
      trainer: 'Rivede i report degli apprendisti e pianifica i loro esami.',
    },
    picker: {
      title: 'Da quale punto di vista vuoi guardare la demo?',
      subtitle: '{count} colleghi in {company}. Ogni ruolo ha le sue attività — le tue spunte restano salvate per ruolo.',
      taskCount: '{total} attività | {total} attività',
    },
    intro: {
      lead: 'è inventata. Anche le persone al suo interno sono inventate. Tutto ciò che si trova sotto la barra appartiene alla demo — al suo interno assumi ruoli diversi. Il tuo account reale non ne è toccato.',
      bridgeBefore: 'Puoi terminare la demo in qualsiasi momento. Tutti i dati qui sotto vengono quindi rimossi e puoi configurare ',
      bridgeAfter: ' per la tua organizzazione.',
      close: 'Chiudi',
    },
    reset: 'Ripristina la demo',
    guestMarker: 'Ospite',
    guestWelcome: {
      invitedBy: 'Un collega di {workspace} ti ha invitato a questa demo.',
      invitedAnon: 'Un collega ti ha invitato a questa demo.',
      body: '{company} è inventata ed è condivisa con tutti gli altri in questa demo. Altri potrebbero aver già provato delle cose, quindi può sembrare usata a metà. «{reset}» offre a tutti un nuovo inizio. Il tuo accesso termina quando termina la demo. Anche le persone al suo interno sono inventate.',
    },
    cancel: 'Annulla',
    rebuildFailed: 'Non è stato possibile ricostruire la demo. Riprova.',
    resetConfirm: {
      title: 'Ripristinare la demo?',
      body: 'Tutto ciò che {company} contiene adesso viene eliminato — compreso quello che tu o i tuoi colleghi avete inserito, e i progressi di tutti nei percorsi — e la demo viene ricreata da zero. Tutti nella demo ricominciano da capo; gli accessi non cambiano.',
      cta: 'Ripristina la demo',
    },
    // The demo bar's "Invite a colleague" dialog (issue 669).
    guests: {
      entry: 'Invita un collega',
      title: 'Invita un collega',
      subtitle: 'I colleghi che inviti vedono questa demo così com’è e possono provarla di persona.',
      close: 'Chiudi',
      loading: 'Caricamento…',
      retry: 'Riprova',
      emailLabel: 'E-mail di lavoro',
      emailPlaceholder: "nome{'@'}azienda.it",
      send: 'Invia invito',
      sendAgain: 'Invia di nuovo',
      slotsLeft: '{count} posto libero | {count} posti liberi',
      exhausted: 'Tutti i {limit} posti sono occupati. Revoca un invito qui sotto per invitare qualcun altro.',
      invalid: 'Inserisci un indirizzo e-mail valido.',
      listTitle: 'In questa demo oltre a te',
      used: '{used} di {limit} occupati',
      empty: 'Nessuno è stato ancora invitato.',
      state: {
        invited: 'Invitato',
        joined: 'Si è unito',
      },
      revoke: 'Revoca',
      revoking: 'Revoca in corso…',
      revokeFor: 'Revoca l’accesso di {email}',
      about: {
        title: 'Che cos’è un ospite',
        sees: 'Un ospite vede questa demo esattamente com’è adesso — compreso tutto ciò che hai già provato. «{reset}» nella barra offre a tutti un nuovo inizio.',
        resets: 'Anche un ospite può ripristinare la demo — per tutti quelli che ne fanno parte.',
        limits: 'Un ospite non può mai terminare la demo né toccare il tuo vero spazio di lavoro.',
        ends: 'Gli ospiti vengono rimossi quando la demo termina.',
      },
      feedback: {
        sent: 'Invito inviato a {email}.',
        resent: 'Invito inviato di nuovo a {email}.',
        undelivered: 'Non è stato possibile consegnare l’e-mail a {email}. {email} è nell’elenco e occupa un posto — invia di nuovo l’invito per riprovare.',
        revoked: 'L’accesso di {email} è stato revocato. Il posto è di nuovo libero.',
        alreadyMember: '{email} ha già accesso a questo workspace.',
        limit: 'Tutti i posti sono occupati. Revoca un invito per invitare qualcun altro.',
        rateLimited: 'Troppi inviti oggi. Riprova più tardi.',
        notLive: 'Gli inviti funzionano solo finché la demo è attiva. È in fase di ricostruzione oppure la configurazione è iniziata — riprova quando la demo sarà di nuovo disponibile.',
        operator: 'Hai effettuato l’accesso come operatore di sistema. Gli operatori non possono invitare colleghi nella demo di un cliente.',
        operatorNotMember: '{email} appartiene a un account operatore di lumi, che non può unirsi alla demo di un cliente. Invita un altro indirizzo.',
        notAPerson: '{email} appartiene a un account che non è una persona, ad esempio un account di servizio. Invita l’indirizzo e-mail di lavoro di un collega.',
        forbidden: 'Solo il proprietario del workspace o un amministratore della suite può invitare colleghi.',
        noticeIncomplete: 'Gli inviti sono sospesi finché le informative per i dipendenti in Avvisi legali non sono completamente compilate.',
        accountClosed: 'Quell’account è stato chiuso e non può essere invitato.',
        unavailable: 'Al momento non è possibile contare gli inviti. Riprova tra un istante.',
        revokeFailed: 'Non è stato possibile revocare l’accesso di {email}. Riprova.',
        generic: 'Qualcosa è andato storto. Riprova.',
      },
    },
    leave: 'Termina la demo',
    continueSetup: 'Continua la configurazione',
    menu: 'Azioni della demo',
    signOut: 'Esci',
    logoutHint: 'Durante la demo, esci dalla porta o dal menu nella barra della demo.',
    journey: {
      title: 'Il percorso di {name}',
      count: '{done} su {total} completate',
      refresh: 'Aggiorna il percorso',
      unknown: 'Alcune verifiche non erano raggiungibili: viene mostrato l’ultimo stato noto.',
      yay: 'Era tutto il percorso di {name}: ben fatto.',
      bridgeAdmin: 'Hai percorso ogni percorso. Quando sei pronto, termina la demo e configura il tuo spazio di lavoro.',
      bridgeUser: 'Hai percorso ogni percorso. Un amministratore può terminare la demo e configurare il vostro spazio di lavoro.',
      blockedReset: 'Un ripristino lo riporta:',
      blocked: {
        gone: 'Ciò che serve a questa attività non c’è più.',
      },
      next: 'A seguire',
      nextCta: 'Apri in {module}',
      footer: 'La demo spunta quello che fai.',
    },
  },
  // The shared notifications popover (NotificationsPopover.vue). Its own namespace: the
  // apps' `notifications.*` keys (inbox page, preferences) are theirs and stay put.
  notificationsPopover: {
    title: 'Notifiche',
    empty: 'Sei aggiornato.',
    markAllRead: 'Segna tutte come lette',
    markRead: 'Segna come letta',
    markUnread: 'Segna come non letta',
    loading: 'Caricamento…',
    openTarget: 'Apri l\'elemento collegato',
    goToAll: 'Vai alle notifiche',
  },
  // The shared place search (PlacePicker.vue). `noMatchAdd` is the wording for hosts whose
  // typed text IS the name (Enter adds it as typed); `noMatch` for hosts that keep it beside the field.
  placePicker: {
    placeholder: 'Cerca una città o un comune …',
    keptHint: 'Salvato esattamente come l’hai scritto, senza località collegata.',
    searching: 'Ricerca in corso …',
    typeMore: 'Scrivi almeno {count} caratteri',
    noMatch: 'Nessuna corrispondenza: il testo resta com’è',
    error: 'Ricerca non riuscita',
    rateLimited: 'Troppe ricerche: riproviamo tra poco',
    resultsAnnouncement: 'Nessun risultato | 1 risultato | {count} risultati',
    clear: 'Rimuovi località',
    noMatchAdd: 'Nessuna città trovata: Invio aggiunge il nome così com’è',
  },
  // The suite's five app names and their one-line launcher descriptions, in this
  // language. THE one copy: component-lib's registry carries no displayed string, and
  // every app merges this underneath its own messages (ADR 0026 section 7).
  lumiModules: {
    suite: {
      name: 'Home',
      description: 'La tua panoramica del posto di lavoro',
    },
    ats: {
      name: 'Recruiting',
      description: 'Posizioni, candidature e processo di selezione',
    },
    time: {
      name: 'Tempo',
      description: 'Rilevazione dei tempi, conti ore di lavoro e approvazioni',
    },
    people: {
      name: 'Personale',
      description: 'Fascicoli del personale, reparti e sedi',
    },
    apprentice: {
      name: 'Apprendisti',
      description: 'Libretti formativi digitali e piani di formazione',
    },
  },
};
